import { RootState } from "./types";
import {
  TWAStatus,
  VUEX_LOCALSTORAGE_KEYS,
  VUEX_PERSISTENT_LOCALSTORAGE_KEYS
} from "@tt-app/constants";
import { parseDate } from "@tt-app/utils";
import GitInfo from "../../../GitInfo.json";

const {
  BOOKMARKED_COURSE_LIMIT_MULTIPLIER,
  COURSE_EXPLORE_SELECTED_LEVEL_INDEXES,
  COURSE_EXPLORE_SELECTED_EXAM_INDEX,
  COURSE_EXPLORE_SELECTED_CATEGORY_IDS,
  COURSE_EXPLORE_SEARCH_STRING,
  GROUP_COURSE_LIMIT_MULTIPLIER,
  GROUP_COURSE_SELECTED_CATEGORY_IDS,
  GROUP_COURSE_SELECTED_EXAM_INDEX,
  GROUP_COURSE_SELECTED_GROUP_INDEX,
  GROUP_COURSE_SELECTED_LEVEL_INDEXES,
  LEARNING_HISTORY_END_DATE,
  LEARNING_HISTORY_START_DATE,
  LEARNING_HISTORY_SELECTED_EXERCISE_TYPE_AND_SKILL
} = VUEX_LOCALSTORAGE_KEYS;

const {
  DEVICE_UUID,
  OPENED_CHAPTERS,
  SELECTED_SKILL_LEVEL_INDEXES
} = VUEX_PERSISTENT_LOCALSTORAGE_KEYS;

const initialState = (): RootState => {
  const localStorageValues: { [key: string]: string } = {};

  Object.values(VUEX_LOCALSTORAGE_KEYS).forEach(key => {
    localStorageValues[key] = localStorage.getItem(key) || "";
  });

  Object.values(VUEX_PERSISTENT_LOCALSTORAGE_KEYS).forEach(key => {
    localStorageValues[key] = localStorage.getItem(key) || "";
  });

  const internalHash = (GitInfo as any).commitHash;

  return {
    androidAppVersion: TWAStatus.NO_VERSION,
    appVersionAlert: false,
    deviceUuid: localStorageValues[DEVICE_UUID] || "",
    internalHash,
    iosAppVersion: "",
    maintenanceMode: {
      active: false,
      message: ""
    },
    navigation: {
      assignmentDetails: {
        entryRoute: undefined
      },
      courseDetails: {
        entryRoute: undefined
      },
      prevPath: undefined
    },
    notificationToasts: [],
    course: {
      bookmarked: {
        limitMultiplier: parseInt(localStorageValues[BOOKMARKED_COURSE_LIMIT_MULTIPLIER], 10) || 1
      },
      group: {
        limitMultiplier: parseInt(localStorageValues[GROUP_COURSE_LIMIT_MULTIPLIER], 10) || 1,
        selectedExamIndex: parseInt(localStorageValues[GROUP_COURSE_SELECTED_EXAM_INDEX], 10) || 0,
        selectedGroupIndex:
          parseInt(localStorageValues[GROUP_COURSE_SELECTED_GROUP_INDEX], 10) || 0,
        selectedLevelIndexes: JSON.parse(
          localStorageValues[GROUP_COURSE_SELECTED_LEVEL_INDEXES] || "{}"
        ),
        selectedCategoryIds: JSON.parse(
          localStorageValues[GROUP_COURSE_SELECTED_CATEGORY_IDS] || "{}"
        )
      },
      explore: {
        searchString: localStorageValues[COURSE_EXPLORE_SEARCH_STRING] || "",
        selectedExamIndex:
          parseInt(localStorageValues[COURSE_EXPLORE_SELECTED_EXAM_INDEX], 10) || 0,
        selectedLevelIndexes: JSON.parse(
          localStorageValues[COURSE_EXPLORE_SELECTED_LEVEL_INDEXES] || "{}"
        ),
        selectedCategoryIds: JSON.parse(
          localStorageValues[COURSE_EXPLORE_SELECTED_CATEGORY_IDS] || "{}"
        )
      },
      openedChapters: JSON.parse(localStorageValues[OPENED_CHAPTERS] || "{}")
    },
    historyInputs: {
      endDate: parseDate(localStorageValues[LEARNING_HISTORY_END_DATE]),
      selectedExerciseTypeAndSkill: JSON.parse(
        localStorageValues[LEARNING_HISTORY_SELECTED_EXERCISE_TYPE_AND_SKILL] ||
          '{ "exerciseType": 0, "exerciseSkill": 0 }'
      ),
      startDate: parseDate(localStorageValues[LEARNING_HISTORY_START_DATE])
    },
    oneSignal: {
      ctaInteraction: undefined,
      initialized: false,
      notificationPermission: undefined
    },
    skills: {
      selectedSkillLevelIndexes: JSON.parse(
        localStorageValues[SELECTED_SKILL_LEVEL_INDEXES] || "{}"
      )
    }
  };
};

const rootState = initialState;

export { rootState };
